import "angular";
import GroupFactory from "./GroupFactory";
import GroupService from "./GroupService";

const GroupModule = angular
    .module("GroupModule", [])
    .service("groupService", GroupService)
    .factory("groupFactory", GroupFactory);

export default GroupModule;
